import { render, staticRenderFns } from "./navbar-dropdown-item.vue?vue&type=template&id=2c785c6b&scoped=true"
import script from "./navbar-dropdown-item.vue?vue&type=script&lang=js"
export * from "./navbar-dropdown-item.vue?vue&type=script&lang=js"
import style0 from "./navbar-dropdown-item.vue?vue&type=style&index=0&id=2c785c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c785c6b",
  null
  
)

export default component.exports